import { replace } from 'out-of-character';

import { GoogleDocsIcon } from '../../../assets/icons/google-docs';
import { embedRegistry } from '../registry';
import type { EmbedDefinition } from '../types';

/**
 * Google Docs URL regex pattern
 * Matches: docs.google.com/document/d/DOCUMENT_ID/...
 * Captures the document ID in group 1.
 */
export const GOOGLE_DOCS_REGEX = /^https?:\/\/docs\.google\.com\/document\/d\/([^/?#]+)/i;

export const matcher = (url: string): boolean => {
  const cleaned = replace(url);

  return GOOGLE_DOCS_REGEX.test(cleaned);
};

const convertToEmbedUrl = (url: string): string => {
  const cleaned = replace(url);
  const match = cleaned.match(GOOGLE_DOCS_REGEX);

  if (!match) return url;

  const documentId = match[1];

  return `https://docs.google.com/document/d/${documentId}/preview`;
};

export const googleDocsProvider: EmbedDefinition = {
  id: 'google-docs',
  label: 'Google Docs',
  icon: <GoogleDocsIcon className="size-5" />,
  placeholder: 'Paste a Google Docs link...',
  invalidUrlMessage: 'Please enter a valid Google Docs URL',
  matcher,
  convertUrl: convertToEmbedUrl,
  renderProps: {
    title: () => 'Google Docs Embed',
  },
};

embedRegistry.register(googleDocsProvider);
